module.exports = __webpack_public_path__ + "static/media/organizer_4.4e69c3e3.jpg";